import { FormControl, useTheme } from '@mui/material'
import React, { FunctionComponent, KeyboardEventHandler } from 'react'
import CreatableSelect from 'react-select/creatable'

import { MyInputLabel } from '../../../../base/components/MyInputs/MyInputLabel'
import { getSelectStyles } from '../../../../base/components/MySelect/selectStyles.tsx'
import { KeyValueProp } from '../../../../base/interfaces/base'

interface OwnProps {
  notas: KeyValueProp<string>[]
  onChange: (notas?: KeyValueProp<string>[]) => void
}

type Props = OwnProps

/**
 * Componente para agregar y eliminar notas rapidas
 * @param props
 * @constructor
 */
const TipoArticuloNotas: FunctionComponent<Props> = (props) => {
  const { notas, onChange } = props
  const [inputValue, setInputValue] = React.useState('')

  const theme = useTheme()

  /**
   * Cuando se cambia el valor del input
   * @param event
   */
  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return
    switch (event.key) {
      case 'Enter':
      case 'Tab': {
        const v = [...(notas || []), { key: inputValue, value: inputValue }]
        setInputValue('')
        onChange(v)
        event.preventDefault()
      }
    }
  }

  return (
    <FormControl fullWidth>
      <MyInputLabel shrink id="select-notas-rapidas">
        Notas Rápidas
      </MyInputLabel>
      <CreatableSelect
        components={{ DropdownIndicator: null }}
        styles={getSelectStyles(theme, false)}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue: any) => {
          onChange(newValue)
        }}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder="Escriba y presione enter o tab..."
        value={notas || []}
        formatOptionLabel={(option) => (option ? `${option.value || ''}` : '')}
        getOptionValue={(option) => option.value}
      />
    </FormControl>
  )
}

export default TipoArticuloNotas
